import { Col, Empty, Row, Spin } from 'antd';
import { default as React, useState } from "react";
import {isSharedProject, Project} from '../../../types/Project';
import styles from '../Studies.module.scss';
import ProjectItem from './ProjectItem';
import {UserDetails} from "../../../actions/api";
import {useAppSelector} from "../../../hooks";
import {selectColleagues} from "../cohortBuilderSlice";
import {GenericSearch} from "../../../components/AppSearch/GenericSearch";


export const CohortBuilderPageSearch: React.FC<{ setFilterText: (s: string) => void }> = ({ setFilterText }) => (
    <GenericSearch
        placeholder="Filter projects by"
        width={200}
        onKeyUp={e => setFilterText((e.target as HTMLInputElement).value)}
    />
);

const isInTitle = (filterText: string, project: Project) => {
    return project.title.toUpperCase().indexOf(filterText.toUpperCase()) > -1
}

const isInDescription = (filterText: string, project: Project) => {
    return project.description.toUpperCase().indexOf(filterText.toUpperCase()) > -1

}

const isInSharedByUserName = (filterText: string, project: Project, colleagues: UserDetails[] | undefined) => {
    if (isSharedProject(project)) {
        const colleague = (colleagues ?? []).find(colleague => colleague.username === project.sharedItem.ownerId)
        return colleague !== undefined && `${colleague.firstName} ${colleague.lastName}`.toUpperCase().indexOf(
            filterText.toUpperCase()
        ) > -1
    }

    return false
}

const filterProjects = (projects: Project[], filterText: string | undefined, colleagues: UserDetails[] | undefined) => {
    const filteredProjects = filterText === undefined || filterText.trim()  === '' ?
        projects
        : projects.filter(project => {
            return isInTitle(filterText, project)
                || isInDescription(filterText, project)
                || isInSharedByUserName(filterText, project, colleagues)
        })


    if (filteredProjects.length === 0) {
        return <Empty />
    } else {
        return filteredProjects.map(project => <ProjectItem key={project.id} study={project} />)
    }

}

const ProjectsList = ({studies, isExampleProjects}: { studies: Project[], isExampleProjects?: boolean }) => {
    const [filterText, setFilterText] = useState<string | undefined>(undefined)
    const colleagues = useAppSelector(selectColleagues)
    return <Row>
        <Col span={24}>
            <div className={styles.headerBorderless}>
                <CohortBuilderPageSearch setFilterText={setFilterText} />
            </div>
        </Col>
        <Col span={24}>
            <div className={styles.projectList} data-testid={isExampleProjects ? "example-projects-list" : undefined}>
                {studies ? filterProjects(studies, filterText, colleagues) : <Spin />}
            </div>
        </Col>
    </Row>
}

export default ProjectsList